export default __webpack_public_path__ + "static/media/screen_viber_1.1d3ea9d9.png";